import React from "react";
import { Helmet } from "react-helmet";
import HomeboundFieldworkGallery from "../components/HomeboundFieldwork";

function HomeboundFieldwork() {
  return (
    <div>
      <Helmet>
        <title>Homebound Fieldwork— Octavio Garcia</title>
      </Helmet>
      <HomeboundFieldworkGallery />
    </div>
  );
}

export default HomeboundFieldwork;
